export const OUT_OF_STOCK_TEXT = `Insufficient stock`;
